import React, { useContext, useEffect, useState } from 'react';

import { ServiceResponse } from '../../app/services/shared/interfaces';
import Breadcrumbs, { BreadcrumbsItem } from '../../template/MainTheme/components/Breadcrumbs';
import DefaultCard from '../../components/default/DefaultCard';

import DefaultModal from '../../components/default/DefaultModal';
import DefaultToolBar from '../../components/default/DefaultToolBar';
import ButtonCreate from '../../components/buttons/ButtonCreate';

import { toast } from 'react-toastify';

import useReactConfirmAlert from '../../hooks/useReactConfirmAlert';
import { AppContext } from '../../contexts/AppContext';
import useContactTypeService from '../../app/services/hooks/useContactTypeService';
import { ContactTypeDataForm, ContactTypeFilters } from '../../app/models/ContactType';
import { useHistory } from 'react-router-dom';
import ContactTypeCreate from './components/ContactTypeCreate';
import ContactTypeEdit from './components/ContactTypeEdit';
import useNavigationPage from '../../hooks/useNavigationPage';
import ContactTypeDataTable from './components/tables/ContactTypeDataTable';

const breadcrumbs: BreadcrumbsItem[] = [
    {
        name: 'ContactTypes',
        url: '/contact-types',
        isActive: true
    }
];

const ContactTypes = () => {
    const { navigationPage } = useNavigationPage();
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { fetchingGetContactTypes, getContactTypes, deleteContactType, activeContactType } =
        useContactTypeService();
    const [contactTypes, setContactTypes] = useState<ContactTypeDataForm[]>([]);

    const [contactTypeIdEdit, setContactTypeIdEdit] = useState<number>(-1);
    const [showingEdit, setShowingEdit] = useState(false);
    const [showingCreate, setShowingCreate] = useState(false);
    const [totalRows, setTotalRows] = useState<number>(0);

    const [contactTypeFilter, setContactTypeFilter] = useState<ContactTypeFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'desc'
    });

    useEffect(() => {
        reloadTable();
    }, [contactTypeFilter]);

    const getAllContactTypes = () => {
        getContactTypes(contactTypeFilter, {
            onSuccess: (response: ServiceResponse) => {
                setContactTypes(response.data.contact_types);
                setTotalRows(response.data.total_rows);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message, {
                    autoClose: 2000
                });

                if (response.data.to_dashboard) {
                    navigationPage('/')
                }
            }
        });
    };

    const showEdit = (incotermId: number) => {
        setShowingEdit(true);
        setContactTypeIdEdit(incotermId);
    };

    const hideEdit = () => {
        setShowingEdit(false);
        setContactTypeIdEdit(-1);
    };

    const showCreate = () => {
        setShowingCreate(true);
    };

    const hideCreate = () => {
        setShowingCreate(false);
    };

    const reloadTable = () => {
        getAllContactTypes();
    };

    const destroy = (contactTypeId: number) => {
        const _text = 'Está a punto de eliminar tipo de contacto #' + contactTypeId;

        useReactConfirmAlert().requestConfirmation({
            title: '¿Estás seguro?',
            message: _text,
            buttons: {
                confirmButton: {
                    label: 'Si, confirmar',
                    onClick: () => {
                        if (showLoading) showLoading('loading', 'Eliminando tipo de contacto...');
                        deleteContactType(contactTypeId, {
                            onSuccess: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().successAlert({
                                    title: 'Éxito',
                                    message: response.message
                                });

                                reloadTable();
                            },
                            onError: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().errorAlert({
                                    title: 'Error',
                                    message: response.message
                                });
                            }
                        });
                    }
                },
                cancelButton: {
                    label: 'No, cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'El tipo de contacto no se ha eliminado.'
                            });
                        }, 0);
                    }
                }
            }
        });
    };


    return (
        <>
            <Breadcrumbs pageSection="Tipo de contacto" breadcrumbs={breadcrumbs} />

            <DefaultCard>
                <DefaultToolBar
                    left={<ButtonCreate callbackCreate={showCreate} title="Nuevo tipo de contacto" />}
                />
                <ContactTypeDataTable
                    contactType={contactTypes}
                    edit={showEdit}
                    destroy={destroy}
                    loading={fetchingGetContactTypes}
                    filter={contactTypeFilter}
                    setFilter={setContactTypeFilter}
                    totalRows={totalRows}
                    callbackSuccess={reloadTable}
                />
            </DefaultCard>

            {showingCreate ? (
                <DefaultModal
                    show={showingCreate}
                    handleClose={hideCreate}
                    title="Crear Tipo de contacto"
                    backdrop={true}
                    showFooter={false}
                >
                    <ContactTypeCreate
                        onSaved={() => {
                            reloadTable();
                            hideCreate();
                        }}
                        onCancel={hideCreate}
                        onError={hideCreate}

                    />
                </DefaultModal>
            ) : null}

            {showingEdit ? (
                <DefaultModal
                    show={showingEdit}
                    handleClose={hideEdit}
                    title="Editar tipo de contacto"
                    backdrop={true}
                    showFooter={false}
                >
                    <ContactTypeEdit
                        contactTypeId={contactTypeIdEdit}
                        onSaved={() => {
                            reloadTable();
                            hideEdit();
                        }}
                        onCancel={hideEdit}
                        onError={hideEdit}
                    />
                </DefaultModal>
            ) : null}
        </>
    );
};

export default ContactTypes;
